import * as React from "react";
import classNames from "classnames/bind";

import UIIcon from "common/blocks/UIIcon";
import styles from "./DefaultErrorView.module.scss";

const cx = classNames.bind(styles);

export interface DefaultErrorViewProps {
    errorText?: string;
    errorTextClassName?: string;
    errorIconClassName?: string;
    errorClassName?: string;
}

const DefaultErrorView = ({
    errorText = "",
    errorTextClassName,
    errorIconClassName,
    errorClassName,
}: DefaultErrorViewProps) => (
    <div className={cx("errorAlert", errorClassName)} role="alert">
        <UIIcon icon="Error" className={cx("errorIcon", errorIconClassName)} />
        <span className={cx("errorText", errorTextClassName)}>{errorText}</span>
    </div>
);

export default DefaultErrorView;
